module.exports = __webpack_public_path__ + "static/media/lavadeira-rio-ecommerce-site-768x591.6de25455.jpg";